import { EMPTY_PROJECT_MASTER_DATA } from '../Constants/projectMasterDataFields';

export const sortMasterDataValues = (values = []) => (
  [...values].sort((left, right) => (
    String(left).localeCompare(String(right), undefined, { sensitivity: 'base' })
  ))
);

const normalizeStringArray = (values) => (
  sortMasterDataValues(Array.isArray(values) ? values : [])
);

export const normalizeProjectMasterData = (payload = {}) => ({
  products: normalizeStringArray(payload.products),
  engagementTypes: normalizeStringArray(payload.engagementTypes),
  deploymentModels: normalizeStringArray(payload.deploymentModels),
  competitiveContexts: normalizeStringArray(payload.competitiveContexts),
  projectStatus: normalizeStringArray(payload.projectStatus),
  tierType: normalizeStringArray(payload.tierType),
  serviceLevel: normalizeStringArray(payload.serviceLevel),
});

export const extractProjectMasterDataFromResponse = (response = {}) => {
  if (!response || typeof response !== 'object') {
    return EMPTY_PROJECT_MASTER_DATA;
  }

  return normalizeProjectMasterData(response);
};
